import script from "./PersonalDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts&setup=true"

import "./PersonalDetails.vue?vue&type=style&index=0&id=908c4a5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-908c4a5c"]])

export default __exports__